module.exports = __webpack_public_path__ + "img/visual_default.dbbf2c2c.png";